import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";

import OfferHistoryPeriodItems from "@features/offer/desktop/offer-menu/components/expanded-period-menu/OfferHistoryPeriodItems";
import PeriodConverter, { Period } from "@state/common/PeriodConverter";

import { ExpandedPeriodMenuItems } from ".";

export function ExpandedPeriodMenu(props: {
	store: {
		toggleUpdateProcessing: () => void;
		periodSubMenu: {
			setPeriodKey: (p: Period) => void;
			periodMenu: { period: Period; name: string }[];
			previousPeriodMenu: { period: Period; name: string }[];
		};
	};
}) {
	const t = useTranslation().t;
	const params = useParams<{ period: string }>();
	const location = useLocation();

	const isPreviousPeriod = PeriodConverter.IsDateString(params.period);
	const [isExpanded, setIsExpanded] = useState(isPreviousPeriod);

	return (
		<nav className="nav--tertiary" data-at="at-ExpandedPeriodMenu">
			<ul className="nav--tertiary__menu">
				<ExpandedPeriodMenuItems store={props.store} />

				{WEBPACK_IS_OFFER_HISTORY_ENABLED &&
					!location.pathname.includes("my-favorites") && (
						<>
							<button
								type="button"
								onClick={() => setIsExpanded((prev) => !prev)}
								className={`nav--tertiary__link ${isPreviousPeriod ? "is-expanded" : ""}`}
								// disabled={location.pathname.includes("my-favorites")}
							>
								<span className="nav--tertiary__title nav--tertiary__title--center u-display--f--grow">
									<label
										htmlFor="period-prev"
										className="input--radio__label input--radio--sml__label"
									/>

									<i className="nav--tertiary__icon u-icon u-icon--base u-icon--previous" />
									<span className="u-display--f--grow">
										{t<string>("OFFER_HISTORY.FINISHED")}
									</span>
									<span className="tag tag--tny tag--danger u-pad--x--2">
										{t<string>("CASINO.NEW_GAME_LABEL")}
									</span>
								</span>
							</button>
							<OfferHistoryPeriodItems
								store={props.store}
								isExpanded={isExpanded}
							/>
						</>
					)}
			</ul>
		</nav>
	);
}
